export default {
  SAVE_LOGIN_DATA_TO_STORE: 'authentication/SAVE_LOGIN_DATA_TO_STORE',
  SAVE_SCOPE_DATA_TO_STORE: 'authentication/SAVE_SCOPE_DATA_TO_STORE',
  SUCCESSFULLY_LOGGED_OUT: 'authentication/SUCCESSFULLY_LOGGED_OUT',
};
